import { withChartLayout } from 'components/common';
import DrainsTubes from 'components/features/chart/drains-tubes/DrainsTubes';

const DrainsTubesPage = withChartLayout('Drains - Tubes')(DrainsTubes);
export default DrainsTubesPage;
